import { IAppState } from '../../common/state';
import { selectIsSpecialProjectFeaturesAvailable } from '../newbuildingSpecialProject';
import { selectIsAgent } from '../user';

export const selectIsNewbuildingPromoBuilderOffersVisible = (state: IAppState) => {
  const isNewbuildingSpecialProjectAvailable = selectIsSpecialProjectFeaturesAvailable(state);
  const isAgent = selectIsAgent(state);

  if (isAgent) {
    return false;
  }

  if (!isNewbuildingSpecialProjectAvailable || !state.featureToggle.isNewbuildingPromoBuilderOffersEnabled) {
    return false;
  }

  if (state.newbuildingPromoBuilderOffers === null) {
    return false;
  }

  return !state.newbuildingPromoBuilderOffers.needShowAdfoxBlock;
};
